module.exports = __webpack_public_path__ + "../resources/img/ic_plus_circle_gray950.a99213b6.svg";